import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Phone, Youtube,} from 'react-feather';
import React,{ useState, useEffect } from "react";
import { FaClock } from 'react-icons/fa';
import Features from './features';
import FooterHomepage from './footer-homepage';
import Country from './country';
import SecuritySection from './securitySection';
import PricingCon from './pricing-con';
import FooterCon from './FooterCon';

function Pricing(){
       const [currency, setCurrency] = useState("");
    const [growthOffer, setGrowthOffer] = useState("");

    // Pricing by region
    const PRICES = {
        KE: {
            monthly: [0, 1799, 4999, 14999],
            yearly: [0, 17990, 49990, 149990],
            currency: "KES",
            growthOffer: "Custom domain"
        },
        US: {
            monthly: [0, 25, 50, 120],
            yearly: [0, 250, 500, 1200],
            currency: "USD",
            growthOffer: "Custom domain"
        }
    };

    const [plans, setPlans] = useState({
        monthly: [0, 0, 0, 0],
        yearly: [0, 0, 0, 0]
    });

    async function loadPricing() {
        let code = localStorage.getItem("kadhr_country_code");

        if (!code) {
            try {
                const res = await fetch("https://ipapi.co/json/");
                const data = await res.json();
                code = data.country_code || "KES";
            } catch {
                code = "KES";
            }
            localStorage.setItem("kadhr_country_code", code);
        }

        const region = code === "KES" || "KE" ? PRICES.KE : PRICES.US;

        setPlans({
            monthly: region.monthly,
            yearly: region.yearly
        });
        setCurrency(region.currency);
        setGrowthOffer(region.growthOffer);
    }

    useEffect(() => {
        loadPricing();
    }, []);      

    return (
        <>                                                                    
            <Helmet>
                <title>Pricing</title>
                <meta name="description" content={`Pricing`} />
            </Helmet>
            <main className="mtopcon0 ovrflwhdn" id="up">
                <a href="https://wa.me/254794072134" target='_blank' className="wappcomms btn-hover float-left">
                    <Phone className='text-white'/>
                </a>
                <div className="row">   
                    
                    <PricingCon/>     
                        
                    <Features/> 

                    <SecuritySection/>

                    <FooterCon/>

                    <FooterHomepage/>


                </div>
            </main>
        </>
    )
}

export default Pricing;
